import * as React from 'react';
import { Form as AntForm } from 'antd';

type FormListProps = {
  // TODO
};

const FormList = ({ children, ...props }: FormListProps & React.ComponentProps<typeof AntForm.List>) => {
  return <AntForm.List {...props}>{children}</AntForm.List>;
};

FormList.defaultProps = {
  // TODO
};

export default FormList;
